import { render, staticRenderFns } from "./VasHeader.vue?vue&type=template&id=307c6a48"
import script from "./VasHeader.vue?vue&type=script&lang=js"
export * from "./VasHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports